import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '@modules/auth/services';
import { LoggingService } from '@app/core/services/logging.service';

@Component({
    selector: 'app-signout-callback',
    template: `<div></div>`,
})
export class SignoutRedirectCallbackComponent implements OnInit {
    private readonly loggingService = inject(LoggingService);
    constructor(private _authService: AuthService) {}

    ngOnInit() {
        this._authService.completeLogout().catch((error) => {
            this.loggingService.error('[SignoutRedirectCallback] Logout callback failed.', error);
        });
    }
}
